import { render, staticRenderFns } from "./basicCreatedWorkLeave.vue?vue&type=template&id=7aa23358&scoped=true&"
import script from "./basicCreatedWorkLeave.vue?vue&type=script&lang=js&"
export * from "./basicCreatedWorkLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa23358",
  null
  
)

export default component.exports